module.exports = __webpack_public_path__ + "static/media/LaunchingCoursioNEXT.3221fe49.mp4";